import {
  Policy,
  IClassicCarPolicy,
  ITransportationGoodsPolicy,
  IPersonalAccidentsPolicy,
  IQuadPolicy,
  IMotorBikePolicy,
  RiskTag,
} from '../interfaces/policies.interface';
import { PolicyMapperRegistry } from './policyMapperRegistry';

type MappedPolicyResult = {
  insurable: unknown;
  title: string;
  tabs: string[];
};

function doMap<K extends RiskTag>(
  typed: Extract<Policy, { risk: { tag: K } }>,
  tag: K
): MappedPolicyResult {
  const mapper = PolicyMapperRegistry[tag];
  const insurable = mapper.map(typed.insurable);
  const title = mapper.getTitle(typed, insurable);
  const tabs = mapper.getTabs?.() ?? [];
  return { insurable, title, tabs };
}

export function MapPolicy(policy: Policy): MappedPolicyResult {
  switch (policy.risk.tag) {
    case 'classic_car':
      return doMap(policy as IClassicCarPolicy, 'classic_car');
    case 'motor_bike':
      return doMap(policy as IMotorBikePolicy, 'motor_bike');
    case 'transportation_goods':
      return doMap(policy as ITransportationGoodsPolicy, 'transportation_goods');
    case 'personal_accidents':
      return doMap(policy as IPersonalAccidentsPolicy, 'personal_accidents');
    case 'quad':
      return doMap(policy as IQuadPolicy, 'quad');
    default:
      throw new Error(`Unsupported risk tag`);
  }
}
